module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-Book.dad6b619.woff";